export interface Toggle<T> {
  current: T;
  previous: T;
}

export const defaultToggle = { current: undefined, previous: undefined };
